import React, { Component, Fragment } from 'react';
import { View } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AppHeader from '../../components/appHeader';
import ListaDepartamento from '../../components/listaDepartamento';
import DepartamentoDetalhe from '../../components/departamentoDetalhe';

import { Creators as departamentoSelecionadoActions } from '../../store/ducks/departamento-selecionado';

import styles from './styles';

import Api from '../../services/Api';

class ListaDepartamentoWrapper extends Component {
    state = {
        idDepartamento: '',
        sameSearch: false,
        query: '',
        list: []
    };

    renderDesktop = () => {
        const { navigation } = this.props,
            { idDepartamento, query, list, sameSearch } = this.state;

        return (
            <View style={styles.container}>
                <View style={styles.content}>
                    <View style={styles.list}>
                        <AppHeader
                            navigation={navigation}
                            onSearchChange={this.onSearchChange}
                        />
                        <ListaDepartamento
                            loadDepartamentoList={this.loadDepartamentoList}
                            onSelect={this.onSelect}
                            sameSearch={sameSearch}
                            query={query}
                            list={list}
                        />
                    </View>
                    <View style={styles.detail}>
                        <DepartamentoDetalhe
                            loadDepartamentoList={this.loadDepartamentoList}
                            idDepartamento={idDepartamento}
                            navigation={navigation}
                            query={query}
                        />
                    </View>
                </View>
            </View>
        );
    };

    render() {
        return <Fragment>{this.renderDesktop()}</Fragment>;
    }

    clearSearchQuery = () => {
        this.onSearchChange('');
    };

    onSearchChange = (query = '') => {
        this.setState({ query, idDepartamento: '' });
    };

    onSelect = (idDepartamento, query = '') => {
        this.props.selectDepartamento({ idDepartamento, query });
        this.setState({ idDepartamento, query });
    };

    loadDepartamentoList = async (sameSearch = false) => {
        const { query } = this.state,
            request = await Api.get('/gestao/departamento', {
                params: { search: query, limit: 200 }
            }),
            list = request.data.data;

        this.setState({ ...this.state, list, sameSearch });
    };
}

const mapStateToProps = ({ departamentoSelecionado }) => ({
    departamentoSelecionado
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...departamentoSelecionadoActions }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListaDepartamentoWrapper);
